import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgInjection = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 15,
	height: 14,
	fill: "currentColor",
	viewBox: "0 0 15 14",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		d: "M11.83 1.694l-.663-.68c-.275-.292-.088-.875.337-.896h.04c.063.002.073.006.101.013.067.016.13.045.185.086.022.016.042.035.062.054l2.052 2.103c.27.29.096.875-.337.897-.143.008-.287-.053-.389-.153l-.663-.68-1.326 1.36.663.68c.034.036.06.075.08.118.089.174.088.398-.028.563-.02.03-.028.035-.052.062l-6.156 6.31c-.08.076-.177.13-.282.148-.036.006-.045.005-.08.006h-1.84l-1.902 1.95c-.286.28-.854.086-.875-.346-.007-.147.051-.294.15-.398l1.901-1.95V9.057c.008-.215.05-.26.15-.372l4.104-4.206c.22-.208.6-.19.778.062.127.18.126.44 0 .619-.021.03-.028.035-.052.062L3.834 9.274v1.36h1.327l5.642-5.784-1.689-1.732c-.27-.29-.1-.875.338-.897h.04c.131.006.232.04.348.153l.663.68 1.327-1.36z"
	})
});
export default SvgInjection;
